<template>
    <div class="overflow-auto">
        <div class="mt-4">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="center"></b-pagination>
        </div>
    </div>
</template>

<script>
    import { BPagination } from 'bootstrap-vue';
    import 'bootstrap-vue/dist/bootstrap-vue.css';

    export default {
        name: 'filter-page',
        components: {
            BPagination
        },
        data() {
            return {
                rows: 0,
                currentPage: this.current,
                perPage: this.limit
            }
        },
        props: {
            total: {
                required: true
            },
            current: {
                required: false,
                default: 1
            },
            limit: {
                required: false,
                default: 4
            }
        }
    }
</script>
